// Module
var code = "<div> <su-multi-select options=\"addLocation.options\" selected=\"content.privacy_locations\" drop-name=\"{{ 'edit.general.settings_location' | translate }}\"></su-multi-select> </div>";
// Exports
module.exports = code;